// Timetable API service

import { apiRequest } from './api';

// ── Types ───────────────────────────────────────────────────

export type TimetableApiRecord = {
    id: string;
    organization_id: string;
    academic_session_id: string;
    class_id: string;
    section_id: string | null;
    subject_id: string | null;
    teacher_id: string | null;
    day_of_week: string; // 'Monday', 'Tuesday', etc.
    period_number: number;
    start_time: string;
    end_time: string;
    room_number: string | null;
    created_at: string;
    updated_at: string;
    academic_session?: { id: string; name: string } | null;
    school_class?: { id: string; name: string; standard: number } | null;
    section?: { id: string; name: string } | null;
    subject?: {
        id: string;
        subject_name: string;
        subject_code: string;
    } | null;
    teacher?: {
        id: string;
        first_name: string;
        last_name: string | null;
    } | null;
};

// ── API Functions ───────────────────────────────────────────

export async function fetchTimetableSlots(params: {
    academic_session_id?: string;
    class_id: string;
    section_id?: string | null;
    teacher_id?: string;
    day_of_week?: string;
    per_page?: number;
}): Promise<TimetableApiRecord[]> {
    const query = new URLSearchParams();
    if (params.academic_session_id) query.set('academic_session_id', params.academic_session_id);
    query.set('class_id', params.class_id);
    if (params.section_id) query.set('section_id', params.section_id);
    if (params.teacher_id) query.set('teacher_id', params.teacher_id);
    if (params.day_of_week) query.set('day_of_week', params.day_of_week);
    query.set('per_page', String(params.per_page ?? 100));

    const res = await apiRequest<TimetableApiRecord[]>(
        `/api/timetables?${query.toString()}`
    );
    return res.data;
}

export type SaveTimetablePayload = {
    academic_session_id: string;
    class_id: string;
    section_id: string | null;
    class_section_subject_id: string;
    teacher_id: string;
    day_of_week: string; // 'Monday' | 'Tuesday' | ... | 'Sunday'
    period_number: number;
    start_time: string; // H:i
    end_time: string;   // H:i
    room_number: string | null;
};

export async function saveTimetableSlot(
    payload: SaveTimetablePayload
): Promise<TimetableApiRecord> {
    const res = await apiRequest<TimetableApiRecord>('/api/timetables', {
        method: 'POST',
        body: JSON.stringify(payload),
    });
    return res.data;
}
